import { useRecoilState } from "recoil";
import {
  userDetail,
  userBlocker,
  userGSTDetails,
  userUdyamDetails,
  userAadharDetails,
  appTheme,
} from "../atoms/index";
import { constant } from "../../utils/utils";
const useSelector = () => {
  const [userDetailVal, setUserDetailVal] = useRecoilState(userDetail);
  const [userBlockerVal, setUserBlockerVal] = useRecoilState(userBlocker);
  const [appThemeVal, setAppThemeVal] = useRecoilState(appTheme);
  const [userGstDetailState, setuserGstDetailState] =
    useRecoilState(userGSTDetails);
  const [userUdyamDetailState, setuserUdyamDetailState] =
    useRecoilState(userUdyamDetails);

  const [userAadharDetailState, setuserAadharDetailState] =
    useRecoilState(userAadharDetails);

  const getRecoilVal = (atomName) => {
    switch (atomName) {
      case constant.atomsName.USER_DETAIL:
        return userDetailVal;
      case constant.atomsName.USER_BLOCKER:
        return userBlockerVal;
      case constant.atomsName.APP_THEME:
        return appThemeVal;
      case constant.atomsName.GST_DETAILS:
        return userGstDetailState;
      case constant.atomsName.UDYAM_DETAILS:
        return userUdyamDetailState;
      case constant.atomsName.AADHAR_DETAILS:
        return userAadharDetailState;
      default:
        throw new Error(`Unknown atom name: ${atomName}`);
    }
  };

  const setRecoilVal = (atomName, data) => {
    switch (atomName) {
      case `${constant.atomsName.USER_DETAIL}`:
        setUserDetailVal(data);
        break;
      case `${constant.atomsName.USER_BLOCKER}`:
        setUserBlockerVal(data);
        break;
      case `${constant.atomsName.APP_THEME}`:
        setAppThemeVal(data);
        break;
      case `${constant.atomsName.GST_DETAILS}`:
        setuserGstDetailState(data);
        break;
      case `${constant.atomsName.UDYAM_DETAILS}`:
        setuserUdyamDetailState(data);
        break;
      case `${constant.atomsName.AADHAR_DETAILS}`:
        setuserAadharDetailState(data);
        break;
      default:
        throw new Error(`Unknown atom name: ${atomName}`);
    }
  };

  return { getRecoilVal, setRecoilVal };
};

export default useSelector;
